import React from 'react'
import { useSelector } from 'react-redux'

import ModalConfirm from '../Common/Modal/ModalConfirm'
import EditProfile from '../EditProfile'
import Login from '../Login'
import MergeModal from '../MergeModal'
import ResetPassword from '../ResetPassword'
import Signup from '../Signup'
import UserProfile from '../UserProfile'

const modalManager = {
  Login,
  Signup,
  ResetPassword,
  UserProfile,
  EditProfile,
  ModalConfirm,
  MergeModal,
}

const Modal = () => {
  const modal = useSelector((state) => state.modal)
  const { isOpen, data } = modal
  if (!isOpen) return null
  if (data) {
    const { typeModal, modalProps } = data
    const ModalComponent = modalManager[typeModal]
    return <ModalComponent {...modalProps} />
  }
}

export default Modal
